import * as React from "react";
import {
    gql,
    useMutation,
    ApolloError
} from "@apollo/client";
import {
    UpdatePartnerExchangeRateMutationMutation,
    UpdatePartnerExchangeRateMutationMutationVariables
} from "../../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";

export const updatePartnerExchangeRateMutation = gql`
  mutation UpdatePartnerExchangeRateMutation(
    $id: String!
    $rate: Float!
  ) {
    updatePartnerExchangeRate(
      id: $id
      rate: $rate
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: UpdatePartnerExchangeRateMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const UpdatePartnerExchangeRateController: React.FC<Props> = ({ children, onMessage }) => {
  const [updatePartnerExchangeRate, { loading, error }] = useMutation<
    UpdatePartnerExchangeRateMutationMutation,
    UpdatePartnerExchangeRateMutationMutationVariables
  >(updatePartnerExchangeRateMutation);

  const submit = async (values: UpdatePartnerExchangeRateMutationMutationVariables) => {
    const { data } = await updatePartnerExchangeRate({
      variables: values,
    });

    const errors = data?.updatePartnerExchangeRate?.errors
      ? normalizeErrors(data.updatePartnerExchangeRate.errors)
      : null;
    const message = data?.updatePartnerExchangeRate?.message ?? undefined;

    if (message && onMessage) {
      onMessage(message);
    }

    return {
      errors,
      message,
    };
  };

  return children({ submit, loading, error });
};
